var parent = require('../../es/typed-array/uint8-clamped-array');

module.exports = parent;
